import { FunctionComponent, useContext, useMemo } from 'react';

import { WorkspaceAvatar } from 'src/components/WorkspaceAvatar';
import { PortalConfigContext } from 'src/context';
import { getPublicImageURL } from 'src/utils/ImageUtils';

interface PortalLogoProps {
  /** whether the logo is a preview logo */
  isPreviewLogo?: boolean;
  /** the URL of the preview logo */
  logoUrlPreview?: string;
}

const PortalLogo: FunctionComponent<PortalLogoProps> = (props) => {
  const { isPreviewLogo = false, logoUrlPreview } = props;
  const portalConfig = useContext(PortalConfigContext);

  const logoPath = useMemo(() => {
    const url = isPreviewLogo
      ? logoUrlPreview
      : portalConfig.assets.logo.iconImageUrl;
    if (url) return getPublicImageURL(url);
    return '';
  }, [isPreviewLogo, logoUrlPreview, portalConfig]);

  return (
    <a href="/" className="no-underline">
      <div className="flex items-center">
        <WorkspaceAvatar
          size={isPreviewLogo ? 19 : 60}
          iconSrc={logoPath}
          workspaceName={portalConfig.name}
        />
      </div>
    </a>
  );
};

export default PortalLogo;
